import React from "react";

function Whoops404() {
  return (
    <div
      className="mx-auto my-auto m-auto w-100 h-100 center"
      style={{
        backgroundColor: "red",
        width: "100%",
        height: "50vh",
        margin: "15px",
      }}
    >
      <h1 className="mx-auto my-auto m-auto w-100 h-100">Resource Not Found</h1>
    </div>
  );
}

export default Whoops404;
